import { render, staticRenderFns } from "./MyNavbar.vue?vue&type=template&id=3a4b54d8&"
import script from "./MyNavbar.vue?vue&type=script&lang=js&"
export * from "./MyNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MyNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports